import React from 'react';
import {toast} from "react-toastify";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const NotFoundPage = () => {
    return (
        navigator.onLine ?
            <Stack width={'90%'} p={3} m={'20px auto'} justifyContent={'center'} alignItems={'center'} bgcolor={"#fff"}
                   borderRadius={4}>
                <Typography color={'primary'} variant={'h1'}>404</Typography>
                <Typography fontSize={14} textAlign={'right'} variant={"caption"}>
                    صفحه مورد نظر در دسترس نمی‌باشد
                    متاسفانه خطایی هنگام انتقال درخواست شما رخ داده است
                     برای پیدا کردن مسیر درست میتوانید به صفحه اول
                    <a href="https://kalamarket.com/"> کالامارکت </a>
                    بروید
                </Typography>
            </Stack>
            : toast.warn('connection Error!', {position: "top-right"})
    );
};

export default NotFoundPage;